import {
  CustomBodyCell,
  CustomHeaderCell,
  CustomTable,
  CustomTableContainer,
  CustomTableRow,
} from '@components/Styles/TableStyle';
import { CustomStack, SectionWrapper } from '@components/Styles/CommonStyle';
import { useNavigate } from 'react-router-dom';
import { Checkbox, TableBody, TableHead, Typography, Select, MenuItem } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { CustomSorting } from '@components/Styles/TableStyle';

import { CustomButton } from '@components/Styles/ButtonStyle';
import Pagination from '@/components/common/Shared/Pagination';
import React from 'react';
import { theme } from '@components/Styles/theme';
import { formatAmount } from '@utils/formatter';
import NewCommentBadge from '@/components/common/Shared/NewCommentBadge';

const PlannedProjectListTableV2 = ({
  projectList,
  projectListTotal,
  staticSearch,
  setStaticSearch,
  page,
  limit,
  setLimit,
  onSearch,
  onDeleteProject,
  checkedProjectList,
  setCheckedProjectList,
}) => {
  const navigate = useNavigate();

  const handleCheckboxChange = (e, projectId) => {
    if (e.target.checked) {
      setCheckedProjectList([...checkedProjectList, projectId]);
    } else {
      setCheckedProjectList(checkedProjectList.filter((id) => id !== projectId));
    }
  };

  return (
    <React.Fragment>
      <SectionWrapper>
        <CustomStack justifyContent="spaceBetween" mb={2}>
          <Typography sx={theme.typography.h4}>예정사업 리스트</Typography>
          <CustomStack justifyContent="spaceBetween" mb={2}>
            <CustomButton
              onClick={() => {
                navigate('/project/plannedProjectCreate');
              }}
            >
              신규 예정 사업 등록
            </CustomButton>
            <CustomButton
              color="error"
              onClick={() => {
                onDeleteProject();
              }}
            >
              삭제
            </CustomButton>
          </CustomStack>
        </CustomStack>

        <CustomTableContainer>
          <CustomTable>
            <TableHead>
              <CustomTableRow>
                <CustomHeaderCell align="center">선택</CustomHeaderCell>
                <CustomHeaderCell align="center">No</CustomHeaderCell>
                <CustomHeaderCell scope="row" align="center">
                  사업명
                  {staticSearch.orderBy === 'project_name' && staticSearch.orderDir === 'ASC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'project_name', orderDir: 'DESC' })}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  ) : staticSearch.orderBy === 'project_name' && staticSearch.orderDir === 'DESC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'project_name', orderDir: 'ASC' })}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                  ) : (
                    <CustomSorting
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'project_name', orderDir: 'ASC' })}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  )}
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  사업시작일
                  {staticSearch.orderBy === 'start_date' && staticSearch.orderDir === 'ASC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'start_date', orderDir: 'DESC' })}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  ) : staticSearch.orderBy === 'start_date' && staticSearch.orderDir === 'DESC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'start_date', orderDir: 'ASC' })}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                  ) : (
                    <CustomSorting
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'start_date', orderDir: 'ASC' })}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  )}
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  사업종료일
                  {staticSearch.orderBy === 'end_date' && staticSearch.orderDir === 'ASC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'end_date', orderDir: 'DESC' })}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  ) : staticSearch.orderBy === 'end_date' && staticSearch.orderDir === 'DESC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'end_date', orderDir: 'ASC' })}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                  ) : (
                    <CustomSorting
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'end_date', orderDir: 'ASC' })}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  )}
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  사업금액
                  {staticSearch.orderBy === 'project_amount' && staticSearch.orderDir === 'ASC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'project_amount', orderDir: 'DESC' })}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  ) : staticSearch.orderBy === 'project_amount' && staticSearch.orderDir === 'DESC' ? (
                    <CustomSorting
                      sorted
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'project_amount', orderDir: 'ASC' })}
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                  ) : (
                    <CustomSorting
                      onClick={() => setStaticSearch({ ...staticSearch, orderBy: 'project_amount', orderDir: 'ASC' })}
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  )}
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  발주사
                  {staticSearch.orderBy === 'ordering_company_name' && staticSearch.orderDir === 'ASC' ? (
                    <CustomSorting
                      sorted
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'ordering_company_name', orderDir: 'DESC' })
                      }
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  ) : staticSearch.orderBy === 'ordering_company_name' && staticSearch.orderDir === 'DESC' ? (
                    <CustomSorting
                      sorted
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'ordering_company_name', orderDir: 'ASC' })
                      }
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                  ) : (
                    <CustomSorting
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'ordering_company_name', orderDir: 'ASC' })
                      }
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  )}
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  거래처
                  {staticSearch.orderBy === 'account_company_name' && staticSearch.orderDir === 'ASC' ? (
                    <CustomSorting
                      sorted
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'account_company_name', orderDir: 'DESC' })
                      }
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  ) : staticSearch.orderBy === 'account_company_name' && staticSearch.orderDir === 'DESC' ? (
                    <CustomSorting
                      sorted
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'account_company_name', orderDir: 'ASC' })
                      }
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                  ) : (
                    <CustomSorting
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'account_company_name', orderDir: 'ASC' })
                      }
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  )}
                </CustomHeaderCell>
                <CustomHeaderCell align="center">
                  사업담당자
                  {staticSearch.orderBy === 'project_manager_name' && staticSearch.orderDir === 'ASC' ? (
                    <CustomSorting
                      sorted
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'project_manager_name', orderDir: 'DESC' })
                      }
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  ) : staticSearch.orderBy === 'project_manager_name' && staticSearch.orderDir === 'DESC' ? (
                    <CustomSorting
                      sorted
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'project_manager_name', orderDir: 'ASC' })
                      }
                    >
                      <KeyboardArrowDownIcon />
                    </CustomSorting>
                  ) : (
                    <CustomSorting
                      onClick={() =>
                        setStaticSearch({ ...staticSearch, orderBy: 'project_manager_name', orderDir: 'ASC' })
                      }
                    >
                      <KeyboardArrowUpIcon />
                    </CustomSorting>
                  )}
                </CustomHeaderCell>
              </CustomTableRow>
            </TableHead>
            <TableBody>
              {projectList.length > 0 ? (
                projectList.map((project, index) => {
                  return (
                    <CustomTableRow>
                      <CustomBodyCell align="center">
                        <Checkbox
                          checked={checkedProjectList.includes(project.id)}
                          onChange={(e) => handleCheckboxChange(e, project.id)}
                        />
                      </CustomBodyCell>
                      <CustomBodyCell align="center">{projectListTotal - ((page - 1) * limit + index)}</CustomBodyCell>
                      <CustomBodyCell>
                        <span
                          onClick={() => navigate(`/project/plannedProjectCreate?id=${project.id}`)}
                          style={{
                            cursor: 'pointer',
                            userSelect: 'none',
                          }}
                        >
                          {project.project_name}
                        </span>
                        <span
                          onClick={() => navigate(`/project/plannedProjectCreate?id=${project.id}&tab=comment`)}
                          style={{
                            cursor: 'pointer',
                            userSelect: 'none',
                            color: 'red',
                            marginLeft: '4px',
                          }}
                        >
                          ({project.comment_count})
                        </span>
                        <NewCommentBadge isNewComment={project.is_read === 0} />
                      </CustomBodyCell>
                      <CustomBodyCell align="center">{project.start_date}</CustomBodyCell>
                      <CustomBodyCell align="center">{project.end_date}</CustomBodyCell>
                      <CustomBodyCell align="right">{formatAmount(project.project_amount)}원</CustomBodyCell>
                      <CustomBodyCell align="center">{project.ordering_company_name}</CustomBodyCell>
                      <CustomBodyCell align="center">{project.account_company_name}</CustomBodyCell>
                      <CustomBodyCell align="center">{project.project_manager_name}</CustomBodyCell>
                    </CustomTableRow>
                  );
                })
              ) : (
                <CustomTableRow>
                  <CustomBodyCell colSpan={8} align="center">
                    등록된 예정사업이 없습니다.
                  </CustomBodyCell>
                </CustomTableRow>
              )}
            </TableBody>
          </CustomTable>

          <Select
            sx={{ mt: 2, width: '100px', height: '40px' }}
            value={limit}
            onChange={(e) => setLimit(e.target.value)}
          >
            {/* <MenuItem value={1}>1</MenuItem>  */} {/* 테스트용 */}
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={30}>30</MenuItem>
          </Select>

          <Pagination count={Math.ceil(projectListTotal / limit) || 1} page={page} onChange={onSearch} />
        </CustomTableContainer>
      </SectionWrapper>
    </React.Fragment>
  );
};

export default PlannedProjectListTableV2;
